// export const API_PORT = '443'
// export const API_URL = `https://odooqa.ifei.com.ar:${API_PORT}`
// export const API_DATABASE = 'devmigracion'
export const API_PORT = '443'
export const API_URL = `https://prododoo.ifei.com.ar:${API_PORT}`
export const API_DATABASE = 'Produccion'
export const DOMAIN_TITLE = 'modool.ar'